import { createContext, useContext, type ReactNode } from 'react';
import * as dataServices from '../services/dataService';
import { withCache } from '../services/offlineCache';

export type EventDataServices = Pick<typeof dataServices,
  | 'attendeeService'
  | 'eventContentService'
  | 'eventService'
  | 'exhibitorService'
  | 'paperService'
  | 'partnerService'
  | 'sessionService'
  | 'speakerService'
>;
export const liveEventDataServices = dataServices as EventDataServices;
type Cache = typeof withCache;

interface EventDataContextValue {
  preview: boolean;
  services: EventDataServices;
  load: Cache;
}

const EventDataContext = createContext<EventDataContextValue>({
  preview: false,
  services: liveEventDataServices,
  load: withCache,
});

export function EventDataProvider({
  children,
  preview = false,
  services,
  cache = withCache,
}: {
  children: ReactNode;
  preview?: boolean;
  services?: Partial<EventDataServices>;
  cache?: Cache;
}) {
  return (
    <EventDataContext.Provider value={{
      preview,
      services: { ...liveEventDataServices, ...services },
      load: preview ? async (_key, loader) => loader() : cache,
    }}>
      {children}
    </EventDataContext.Provider>
  );
}

export function useEventData() {
  return useContext(EventDataContext);
}
